import 'bootstrap-icons/font/bootstrap-icons.css';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import TopBar from '../../hooks/TopBar';
import Calendar from './calendars/App';
import Schedules from './calendars/Schedules';
import DiscoverEvents from './events/components/Discover';
import MyEvents from './events/components/List';
import ChatList from './friends/ChatList';
import FriendList from './friends/FriendList';
import PendingRequests from './friends/PendingList';
import SearchModal from './friends/SearchModal';
import MatchModal from './match/MatchModal';

const PHLayout = () => {
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showMatchModal, setShowMatchModal] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const myFriends = ['Alice', 'Bob', 'Charlie', 'Diana', 'Ethan'];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' 
      , backgroundColor: '#b94a13' , color: 'white'
      }}>
      <TopBar />

      {isMobile ? (
        // MOBILE: single scroll
        <div style={{ 
          flex: 1, 
          overflowY: 'auto', 
          padding: '10px', 
          display: 'flex', 
          flexDirection: 'column', 
          gap: '20px'//, 
          // background: '#ff9b45' 

        }}>
          <FriendsSection myFriends={myFriends} onSearch={() => setShowSearchModal(true)} onOpenMatchModal={() => setShowMatchModal(true)} />
          <ChatSection />
          <MiddleContainer selectedDate={selectedDate} setSelectedDate={setSelectedDate} events={events} setEvents={setEvents} isMobile={true} />
        </div>
      ) : (



        <div style={{ display: 'flex', flex: 1, overflow: 'hidden'}}>

          <div
            style={{
              width: '20%',
              //height: '100vh', // take full vertical space
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start', // align content to top
              padding: '10px',
            // background: 'linear-gradient(145deg, #993c11 0%, #ffd36b 100%)', // golden gradient
             // boxShadow: '4px 4px 12px rgba(0,0,0,0.3), -2px -2px 8px rgba(255, 215, 0, 0.4)',
             background: '#FFFAF0',// for friend side bar
             overflowY: 'auto',
             border: 'solid 1px #b84a13',
             margin: '5px',
             borderRadius: '12px',
            }}
          >
            <FriendsSidebarContent
              myFriends={myFriends}
              onSearch={() => setShowSearchModal(true)}
              onOpenMatchModal={() => setShowMatchModal(true)}
            />
          </div>




          <div style={{ 
            flex: 1, 
            margin: '5px',
            //padding: '20px', 
            display: 'flex', 
            flexDirection: 'column', 
            //gap: '20px', 
            overflowY: 'auto',
            background: 'rgb(255, 250, 240)',
            borderRadius: '12px',
            border: 'solid 10px #b84a13',
           }}>
            <MiddleContainer selectedDate={selectedDate} setSelectedDate={setSelectedDate} events={events} setEvents={setEvents} isMobile={false} />
          </div>

          <div
            style={{
              /*
              width: '20%',
              padding: '10px',         // optional, smaller padding
              borderRadius: '0',       // remove rounding
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start', // keep children left-aligned
              */
              width: '20%',
              //height: '100vh', // take full vertical space
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start', // align content to top
              padding: '10px',
              // background: 'linear-gradient(145deg, #993c11 0%, #ffd36b 100%)', // golden gradient
              // boxShadow: '4px 4px 12px rgba(0,0,0,0.3), -2px -2px 8px rgba(255, 215, 0, 0.4)',
              background: '#FFFAF0',// for friend side bar
              overflowY: 'auto',
              border: 'solid 1px #b84a13',
              margin: '5px',
              borderRadius: '12px',
            }}
          >
            <h3
              style={{
                padding: 0,           // no padding
                margin: 0,            // no margin
                borderRadius: '6px',
               //  color: '#ffffff',
                fontSize: '30px',
                fontWeight: '700',
                fontStyle: 'bolder',
                color: '#740A03',
                fontFamily: 'Arial, sans-serif',
              }}
            >
              CHAT
            </h3>

            <div
              style={{
                padding: 0,           // no padding
                margin: 0,            // no margin
                width: '100%',
                overflowY: 'auto',
              }}
            >
              <ChatList />
            </div>

          </div>

        </div>
      )}

      {showSearchModal && <SearchModal searchTerm="" onClose={() => setShowSearchModal(false)} />}
      {showMatchModal && <MatchModal onClose={() => setShowMatchModal(false)} />}
    </div>
  );
};

export default PHLayout;

/* === Subcomponents === */
function MiddleContainer({ selectedDate, setSelectedDate, events, setEvents, isMobile }) {


  return (
    <>
      <div
        style={{
          height: '100vh',
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '20px',
         // background: 'linear-gradient(145deg, #ff9b45, #db5)', // golden-orange gradient
          padding: '20px',
          borderRadius: '12px',                               // soft corners for 3D effect
      //    boxShadow: 'inset 2px 2px 6px rgba(0,0,0,0.2), 4px 4px 12px rgba(0,0,0,0.15)', // inner + outer shadow
        }}
      >


        <div style={{ 
          padding: '5px',
          flex: 2,
          borderRadius: '12px',
          border: '10px solid #b84a13', 
          }}>
          <Calendar onDateClick={setSelectedDate} />
        </div>

        <div
          style={{
            flex: 1,
            padding: '5px',
            border: '10px solid #b84a13', 
           // color: '#e7e1e1',
            borderRadius: '12px',          // rounded corners
            // boxShadow: '4px 4px 12px rgba(0,0,0,0.3), inset 2px 2px 6px rgba(255,255,255,0.05)', // mounted effect
            // background: 'linear-gradient(145deg, #e93701ff, rgba(248, 179, 29, 0.89))',  // golden gradient for depth

          }}
        >

          <h6
            style={{
              letterSpacing: '1.5px',    // stretched out text
              textTransform: 'uppercase',
              fontSize: '30px',
              fontWeight: '700',
              fontStyle: 'bolder',
              color: '#740A03',
              fontFamily: 'Arial, sans-serif',
            //  color: '#ffffffff',          // muted professional gray
              margin: 0,

            }}
          >
            SCHEDULE
          </h6>

          <p
            style={{
              fontSize: '14px',          // smaller but readable
              fontWeight: '600',         // slightly bold
              margin: '4px 0 0 0',       // reduced spacing
             // color: '#ffffffff',          // dark professional color
            }}
          >
            
          </p>

          <Schedules selectedDate={selectedDate} />
        </div>
      </div >



      {/* Events */}
      < div
        style={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: '20px',
         //  backgroundColor: '#ff9b45',
          borderRadius: '12px',
          height: isMobile ? 'auto' : '245px',
          padding: '20px',
          paddingTop: '0', // remove extra space above events
      //    boxShadow: '6px 6px 12px rgba(0,0,0,0.3)', // mounted 3D shadow
        }
        }
      >
        <div
          style={{
            flex: 1,
            padding: '20px',
            overflowY: 'auto',
           border: '10px solid #b84a13',
            borderRadius: '12px',
            //borderRadius: '10px', // inner cards slightly rounded for mounted effect
         //   boxShadow: '4px 4px 8px rgba(0,0,0,0.2)', // individual 3D shadow

          //  color: '#fff', // make all text white

          }}
        >
          <MyEvents events={events} setEvents={setEvents} />
        </div>

        <div
          style={{
            flex: 1,
            padding: '20px',
            overflowY: 'auto',
            border: '10px solid #b84a13',
            borderColor: '#b84a13',
            borderRadius: '10px',
          //  color: '#fff', // make all text white

        //    boxShadow: '4px 4px 8px rgba(0,0,0,0.2)', // individual 3D shadow
          }}
        >

          <DiscoverEvents events={events} setEvents={setEvents} />
        </div>
      </div >

    </>
  );
}

function FriendsSection({ myFriends, onSearch, onOpenMatchModal }) {
  return (
    <div
      style={{
       background: '#ff9b54',
        padding: '15px',
        borderRadius: '12px',                       // rounded for mounted effect
       color: 'white',
     //   boxShadow: '6px 6px 12px rgba(0,0,0,0.3)', // mounted 3D shadow
      }}
    >
      <h3
        onClick={onSearch}
        style={{
          margin: 0,
          padding: '8px 12px',
          borderRadius: '6px',
      //    color: '#333',
          textAlign: 'center',
          cursor: 'pointer',
          fontSize: '40px',
   //       textShadow: '1px 1px 2px #aaa, -1px -1px 2px #fff',
        }}
      >
        FRIENDS LIST
      </h3>




      <div style={{ display: 'flex', marginBottom: '10px', marginTop: '10px' }}>
        <input
          type="text"
          placeholder="Search users..."
          readOnly
          onFocus={onSearch}
          onClick={onSearch}
          style={{
            flex: 1,
            padding: '8px 10px',
           // border: '1px solid #060101',
            borderRight: 'none',
            borderRadius: '6px 0 0 6px',
            cursor: 'pointer',
       //   boxShadow: 'inset 1px 1px 4px rgba(0,0,0,0.2)', // subtle mounted inset
          }}
        />

      </div>

      <button
        onClick={onOpenMatchModal}
        style={{
          ...iconButton,
       //   boxShadow: '2px 2px 6px rgba(0,0,0,0.2)', // mounted effect
          borderRadius: '8px',
          width: '100%',
          marginBottom: '10px',
          fontSize: '20px',
          fontFamily: 'arial, sans-serif',
          fontWeight: '700',
          backgroundColor: '#C3110C',
        }}
      >
        MATCH
      </button>

      <div
        style={{
          borderRadius: '10px',
        //  boxShadow: '4px 4px 8px rgba(0,0,0,0.2)', // mounted cards for friends
          padding: '10px',
          marginBottom: '10px',
        //  background: '#ffd699',
        }}
      >
        <FriendList />
      </div>

      <div
        style={{
          borderRadius: '10px',
          boxShadow: '4px 4px 8px rgba(0,0,0,0.2)', // mounted cards for pending
          padding: '10px',
         // background: '#ffd699',
        }}
      >
        <PendingRequests />
      </div>
    </div>
  );
}


function ChatSection() {
  return (
    <div style={{ // background: '#ffe0b3',
       padding: '15px', borderRadius: '8px'//, color: '#333' 

    }}>
      <h3>CHAT</h3>
      <ChatList />
    </div>
  );
}

function FriendsSidebarContent({ myFriends, onOpenMatchModal, onSearch }) {
  return (
    <div
      style={{
        borderRadius: '12px',
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        flex: 1,
        textAlign: 'left', // all child text left-aligned by default
      
         color: '#fff',

      }}
    >
      <h3
        style={{
          margin: 0,
          fontSize: '30px',
          fontWeight: '700',
          fontStyle: 'bolder',
          color: '#740A03',
          fontFamily: 'Arial, sans-serif',
       //   textShadow: ` 1px 1px 0 #d1d5db,           2px 2px 2px rgba(0,0,0,0.4)   `,


        }}
      >
        FRIEND LIST
      </h3>

      <div
        onClick={onSearch}
        style={{
          flex: 1,
          padding: '8px 10px',
          fontSize: '14px',
        //  border: '1px solid #db5',
          borderRadius: '6px',
       //   background: 'linear-gradient(145deg, #ff9b54 0%, #db5 100%)',
              background: 'white',

          color: 'black',
          cursor: 'pointer',
      //    boxShadow: 'inset 1px 1px 4px rgba(0,0,0,0.2)',
          marginBottom: '10px',
          textAlign: 'left', // override previous center
          border: 'solid 1px #280905',
        }}
      >
        Search users....
      </div>

      <button
        onClick={onOpenMatchModal}
        style={{
          ...iconButton,
          fontSize: '20px',
          fontFamily: 'FF9B54, sans-serif',
          borderRadius: '20px',
          padding: '10px 16px',
          width: '100%',
          textAlign: 'center',
          fontSize: '20px',
          fontFamily: '#FFF6DE, sarial, sans-serif',
          fontWeight: '700',
          backgroundColor: '#C3110C',
          color: '#FFF6DE',
       //  backgroundColor: '#ff6a00',
       //   color: '#FFFFFF',
          border: 'none',
          cursor: 'pointer',
      //    boxShadow: '0 4px #7a0000',  // gives a "lifted" shadow
          transform: 'translateY(0)',   // base position
        }}
        onMouseDown={(e) => (e.currentTarget.style.transform = 'translateY(4px)')}
        onMouseUp={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
      >
        MATCH
      </button>




      <div
        style={{
          marginTop: '15px',
          borderRadius: '12px',
          background: 'transparent',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          height: '100%',
          overflowY: 'auto',
          textAlign: 'left', // ensures FriendList and PendingRequests are left-aligned
        }}
      >



        <FriendList />




        <PendingRequests />


      </div>

    </div>

  );
}



const iconButton = {
 // background: '#fff',
 // color: '#ff9b45',
  padding: '10px 14px',
  border: 'none',
  borderRadius: '6px',
  fontSize: '14px',
  cursor: 'pointer'
};
